import * as React from 'react';

export const NavigationPaneRouteParamsContext = React.createContext<Record<string, string>>(null);
